import styled from 'styled-components';
import { getColorWithAlpha } from '@elfsight/lib-utils';
import { Typography } from '@elfsight/widget-ui';
import { getInvertedColor } from '@elfsight/widget-utils';
import { useSettings } from '@wu/widget-core';
import { Divider } from './divider';

export function Footer() {
  const { resultFooter, resultBackgroundColor } = useSettings();

  if (!resultFooter) {
    return null;
  }

  return (
    <Container>
      <Divider />
      <Typography
        lineHeight="14px"
        textStyle={{ fontSize: 12 }}
        color={getColorWithAlpha(getInvertedColor(resultBackgroundColor), 0.7)}
        dangerouslySetInnerHTML={{ __html: resultFooter }}
      />
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding-top: 24px;
`;
